import { actions, types } from './requests'
export const GETDETAILEDCLIENTORDERLIST_TYPES = {
    ...types('GETDETAILEDCLIENTORDERLIST'),
}
export const GETDETAILEDCLIENTORDERLIST_ACTIONS = {
    ...actions('GETDETAILEDCLIENTORDERLIST'),
}
